import React from 'react';

const ClipboardIcon = React.memo(() => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" rx="10" fill="black" fill-opacity="0.88" />
    <rect x="6" y="6" width="8" height="8" fill="white" />
  </svg>
));

export default ClipboardIcon;
